import ClientVulnerabilityModal from "./components/ClientVulnerabilityModal";
import { confirmable, createConfirmation } from "../../../hooks/DialogMountPoint";
import AccountVulnerabilityStatusModal from "./components/AccountVulnerabilityStatusModal";

export function openClientVulnerabilityModal(masterAccountId) {
    return createConfirmation(confirmable(ClientVulnerabilityModal))({
        dialogId: 'client_factfind_vulnerability_modal',
        masterAccountId
    });
}

export function openAccountVulnerabilityStatusModal(masterAccountId) {
    return createConfirmation(confirmable(AccountVulnerabilityStatusModal))({
        dialogId: 'client_factfind_vulnerability_status_modal',
        masterAccountId
    });
}